import React from "react";
import KnowledgeBase from "../../components/pages/kb/KnowledgeBase";

export default function KnowledgePage() {
  return <KnowledgeBase />;
}
